import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import "../../CSS/Global.css";
import "../../CSS/Quiz.css";

const harryPotterQuestions = [
    {
      question: "Qual é o nome da competição em que Harry é inesperadamente inscrito?",
      options: ["Torneio Tribruxo", "Copa Mundial de Quadribol", "Campeonato Bruxo", "Torneio de Quadribol"],
      answer: 0,
    },
    {
      question: "Qual escola é representada por Viktor Krum no Torneio Tribruxo?",
      options: ["Beauxbatons", "Durmstrang", "Hogwarts", "Ilvermorny"],
      answer: 1,
    },
    {
      question: "Qual é o nome do feitiço que Harry usa para convocar sua vassoura durante a primeira tarefa?",
      options: ["Accio", "Expelliarmus", "Lumos", "Wingardium Leviosa"],
      answer: 0,
    },
    {
      question: "Quem foi o verdadeiro responsável por colocar o nome de Harry no Cálice de Fogo?",
      options: ["Barty Crouch Jr.", "Severo Snape", "Lord Voldemort", "Alvo Dumbledore"],
      answer: 0,
    },
    {
      question: "Qual criatura Harry enfrenta na primeira tarefa do Torneio Tribruxo?",
      options: ["Dragão", "Sereias", "Aranha Gigante", "Grindylow"],
      answer: 0,
    },
    {
      question: "Qual feitiço é usado para revelar a verdadeira identidade de Barty Crouch Jr.?",
      options: ["Veritaserum", "Legilimens", "Expelliarmus", "Prior Incantato"],
      answer: 0,
    },
    {
      question: "Quem é o campeão de Hogwarts originalmente escolhido pelo Cálice de Fogo?",
      options: ["Cedrico Diggory", "Harry Potter", "Viktor Krum", "Fleur Delacour"],
      answer: 0,
    },
    {
      question: "Qual feitiço Harry usa contra Voldemort no cemitério?",
      options: ["Expelliarmus", "Avada Kedavra", "Crucio", "Accio"],
      answer: 0,
    },
    {
      question: "Quem avisa Harry sobre a última tarefa no labirinto?",
      options: ["Cedrico Diggory", "Alastor Moody", "Hagrid", "Ludo Bagman"],
      answer: 1,
    },
    {
      question: "Qual é a maldição usada por Voldemort para matar Cedrico Diggory?",
      options: ["Avada Kedavra", "Crucio", "Imperio", "Sectumsempra"],
      answer: 0,
    },
    {
      question: "Qual objeto é usado como uma chave de portal para levar Harry ao cemitério?",
      options: ["O Cálice de Fogo", "A Taça Tribruxo", "A Varinha de Sabugueiro", "O Mapa do Maroto"],
      answer: 1,
    },
    {
      question: "Quem ensina as Maldições Imperdoáveis em 'O Cálice de Fogo'?",
      options: ["Alastor Moody", "Severo Snape", "Alvo Dumbledore", "Remo Lupin"],
      answer: 0,
    },
    {
      question: "Qual personagem é morto por Voldemort no cemitério?",
      options: ["Cedrico Diggory", "Sirius Black", "Alvo Dumbledore", "Lily Potter"],
      answer: 0,
    },
    {
      question: "Quem revela ser Barty Crouch Jr. disfarçado durante o Torneio Tribruxo?",
      options: ["Alastor Moody", "Severo Snape", "Ludo Bagman", "Igor Karkaroff"],
      answer: 0,
    },
    {
      question: "Quem ajuda Harry a resolver o enigma da segunda tarefa?",
      options: ["Dobby", "Neville Longbottom", "Hermione Granger", "Rony Weasley"],
      answer: 1,
    },
  ];
  

const HarryPotterGobletQuiz: React.FC = () => {
  const [shuffledQuestions, setShuffledQuestions] = useState<any[]>([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [score, setScore] = useState(0);
  const [isAnswerSubmitted, setIsAnswerSubmitted] = useState(false);
  const [isQuizFinished, setIsQuizFinished] = useState(false);

  function shuffleOptions(options: string[]): string[] {
    const shuffledOptions = [...options];
    for (let i = shuffledOptions.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledOptions[i], shuffledOptions[j]] = [shuffledOptions[j], shuffledOptions[i]];
    }
    return shuffledOptions;
  }

  useEffect(() => {
    const shuffled = harryPotterQuestions.map((question) => {
      const options = shuffleOptions(question.options);
      const correctAnswerIndex = options.indexOf(question.options[question.answer]);
      return {
        ...question,
        options,
        answer: correctAnswerIndex,
      };
    });
    setShuffledQuestions(shuffled);
  }, []);

  const handleOptionSelect = (index: number) => {
    if (!isAnswerSubmitted) {
      setSelectedOption(index);
    }
  };

  const handleSubmitAnswer = () => {
    if (selectedOption !== null) {
      const isCorrect = selectedOption === shuffledQuestions[currentQuestionIndex].answer;
      if (isCorrect) {
        setScore((prevScore) => prevScore + 1);
      }
      setIsAnswerSubmitted(true);
    }
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex < shuffledQuestions.length - 1) {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      setSelectedOption(null);
      setIsAnswerSubmitted(false);
    } else {
      setIsQuizFinished(true);
    }
  };

  const handlePlayAgain = () => {
    window.location.reload(); // Recarrega a página para reiniciar o quiz
  };

  const handleGoBack = () => {
    window.location.href = "/quiz"; // Redireciona para a rota "/quiz"
  };

  return (
    <div>
      <div className="header">
        <Header activePage="quiz" />
      </div>

      <div className="quiz-container">
        {!isQuizFinished ? (
          shuffledQuestions.length > 0 && (
            <>
              <h2>{shuffledQuestions[currentQuestionIndex].question}</h2>
              <div className="options">
                {shuffledQuestions[currentQuestionIndex].options.map(
                  (option: string, index: number) => (
                    <button
                      key={index}
                      className={`option-button ${
                        selectedOption === index ? "selected" : ""
                      } ${
                        isAnswerSubmitted
                          ? index === shuffledQuestions[currentQuestionIndex].answer
                            ? "correct"
                            : index === selectedOption
                            ? "incorrect"
                            : ""
                          : ""
                      }`}
                      onClick={() => handleOptionSelect(index)}
                      disabled={isAnswerSubmitted}
                    >
                      {option}
                    </button>
                  )
                )}
              </div>
              {isAnswerSubmitted ? (
                <button className="next-button" onClick={handleNextQuestion}>
                  Próxima
                </button>
              ) : (
                <button
                  className="submit-button"
                  onClick={handleSubmitAnswer}
                  disabled={selectedOption === null}
                >
                  Confirmar
                </button>
              )}
            </>
          )
        ) : (
          <div className="quiz-modal">
            <div className="quiz-modal-content">
              <h2>Quiz Concluído!</h2>
              <p>Sua pontuação: {((score / shuffledQuestions.length) * 100).toFixed(2)}%</p>
              <div className="modal-buttons">
                <button onClick={handlePlayAgain} className="modal-button">
                  Jogar Novamente
                </button>
                <button onClick={handleGoBack} className="modal-button">
                  Voltar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default HarryPotterGobletQuiz;
